module.exports = __webpack_public_path__ + "img/videoTowerSuperior.6d2188d3.webp";